const HERO_PROMPTS = [
  "✏️ Draw · Send · Reply 💬",
  "🖍️ Doodle · Share · Smile 😊",
  "✍️ Sketch · Send · Connect 🤝",
  "🖊️ Scribble · Surprise · Delight 🎉",
  "🎨 Create · Send · Inspire 💡",
  "🖌️ Draw · Share · Love 💜",
  "✏️ Sketch · Send · Wonder ⭐",
  "🌈 Doodle · Send · Brighten ☀️",
  "🪄 Make · Send · Magic 💫",
  "💭 Think · Draw · Share 💬",
];

export function getShuffledHeroPrompts() {
  const pool = [...HERO_PROMPTS];
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  return pool;
}
